import { render, staticRenderFns } from "./assignStaff.vue?vue&type=template&id=3cc2c9de&"
import script from "./assignStaff.vue?vue&type=script&lang=js&"
export * from "./assignStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports